






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'text--element-widget',
})
export default class TextElementWidget extends Vue {
  @Prop({ type: String, required: true }) text!: string;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }
}
